export default {
    data : [
        {
            id:'data_kategori', type:'info', label:'Master Kategori', hidden: 'no',
            child: [
                {id:'id', content_text: 'text', type:'text', label:'Id', hidden: 'yes'},
                {id:'nama', content_text: 'text', type:'text', label:'Nama', hidden: 'no'},
                {id:'nama_keterangan', content_text: 'text', type:'text', label:'Nama Keterangan', hidden: 'no'},
                {id:'keterangan', content_text: 'text', type:'text', label:'Keterangan', hidden: 'no'},
                {id:'max_download', content_text: 'number', type:'text', label:'Max Download', hidden: 'no'},
                {id:'max_upload', content_text: 'number', type:'text', label:'Max Upload', hidden: 'no'},
            ]

        }
    ]
}